(() => {

  /* =====================================================
     RÉGLAGES (en pixels)
     ===================================================== */

  const SPACE_ABOVE = 6;   /* espace entre la ligne de stock et la pastille (quand elle est dessous) */
  const SPACE_BELOW = 6;   /* espace entre la pastille et le bloc d'après (quand elle est dessous) */
  const SPACE_AFTER_CTA = 14;   /* espace entre le bouton « Ajouter au panier » et la ligne de stock / pastille */

  /* MOBILE UNIQUEMENT — plus le chiffre est négatif, plus l'écart est réduit */
  const MOBILE_PILL_TOP = 10;     /* écart entre « Chez vous sous… » et la pastille */
  const MOBILE_BLOCKS_TOP = -20;  /* écart entre « Un doute… » et « Livraison à domicile » */


  const lang = (document.documentElement.lang || 'fr').slice(0, 2);

  const I18N = {
    fr: { fallback: 'Paiement en 4x ou 12x disponible', free: 'sans frais', approx: 'environ' },
    en: { fallback: 'Pay in 4x or 12x available',       free: 'no fees',    approx: 'about' },
    de: { fallback: 'Zahlung in 4× oder 12× möglich',    free: 'ohne Gebühren', approx: 'ca.' }
  };
  const T = I18N[lang] || I18N.fr;

  /* Texte du lien « Cliquez pour en savoir plus » du widget Alma */
  const MORE = /savoir plus|learn more|mehr erfahren|mehr/i;

  /* Texte de la ligne de stock / délai (FR, EN, DE) */
  const STOCK_RE = /en stock|sur commande|livré sous|chez vous sous|in stock|on order|delivered|auf lager|auf bestellung|lieferzeit|geliefert/i;

  /* Libellé du total sur la fiche produit (FR, EN, DE) */
  const TOTAL_RE = /^\s*(total\s*ttc|total\s*incl\.?\s*(vat|tax)|gesamt(preis)?\s*inkl\.?\s*(mwst|ust)\.?)\s*:?\s*$/i;

  /* Largeur à partir de laquelle on est en « ordinateur » */
  const DESKTOP_QUERY = '(min-width: 990px)';


  /* ---------- Styles ---------- */

  const style = document.createElement('style');
  style.textContent = `
    .mineral-alma-pill {
      display: flex;
      width: fit-content;
      max-width: 100%;
      align-items: center;
      gap: 8px;
      margin: ${SPACE_ABOVE}px 0 ${SPACE_BELOW}px;
      padding: 6px 12px;
      border: 0;
      border-radius: 999px;
      background: #f3f4ef;
      color: inherit;
      font-family: inherit;
      font-size: 13px;
      line-height: 1.2;
      white-space: nowrap;
      cursor: pointer;
    }
    .mineral-alma-pill:hover { background: #eceee4; }

    /* ORDINATEUR : la pastille se superpose à droite de la ligne de stock,
       le texte vert reste à sa place, à gauche */
    .mineral-alma-pill.is-inline {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      margin: 0;
      padding: 4px 10px;
      z-index: 5;
      pointer-events: auto !important;
    }

    /* la fenêtre Alma (ajoutée dans <body>) passe au-dessus du menu noir */
    body > [class*="alma" i],
    body > [id*="alma" i] {
      z-index: 2147483647 !important;
    }

    /* MOBILE / TABLETTE : écarts réduits */
    @media (max-width: 989px) {
      .mineral-alma-pill { margin-top: ${MOBILE_PILL_TOP}px; }
      .mineral-delivery-wrap { margin-top: ${MOBILE_BLOCKS_TOP}px; }
    }

    .mineral-alma-info {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: #c9cbc3;
      color: #fff;
      font-size: 11px;
      font-weight: 700;
    }
    .mineral-alma-pill.is-overlap {
      position: relative;
      z-index: 5;
      pointer-events: auto !important;
    }


    /* fenêtre de secours (échéancier) */
    .mineral-alma-fallback {
      position: fixed; inset: 0; z-index: 2147483647;
      display: flex; align-items: center; justify-content: center;
      padding: 16px; background: rgba(0, 0, 0, .45);
    }
    .mineral-alma-fallback .maf-card {
      position: relative; width: 100%; max-width: 420px;
      padding: 28px 24px 24px; border-radius: 14px;
      background: #fff; color: #222; font-size: 15px; line-height: 1.4;
      box-shadow: 0 10px 40px rgba(0, 0, 0, .25);
    }
    .mineral-alma-fallback h3 { margin: 0 0 14px; font-size: 18px; }
    .mineral-alma-fallback .maf-close {
      position: absolute; top: 8px; right: 12px; border: 0; background: none;
      font-size: 28px; line-height: 1; cursor: pointer; color: #555;
    }
    .mineral-alma-fallback .maf-intro { margin: 0 0 10px; font-weight: 600; }
    .mineral-alma-fallback .maf-list { list-style: none; margin: 0 0 8px; padding: 0; }
    .mineral-alma-fallback .maf-list li,
    .mineral-alma-fallback .maf-total {
      display: flex; justify-content: space-between; gap: 12px;
      padding: 9px 0; margin: 0; border-bottom: 1px solid #e6e7e0;
    }
    .mineral-alma-fallback .maf-total { border-bottom: 0; font-weight: 600; }
    .mineral-alma-fallback .maf-note { margin: 10px 0 18px; color: #555; font-size: 13px; }
    .mineral-alma-fallback .maf-btn {
      width: 100%; padding: 12px; border: 0; border-radius: 8px;
      background: #2f3b2a; color: #fff; font: inherit; cursor: pointer;
    }

    .mineral-alma-hidden {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden !important;
      clip: rect(0 0 0 0) !important;
      white-space: nowrap !important;
    }
  `;
  document.head.appendChild(style);


  /* ---------- Outil : parcourt aussi À L'INTÉRIEUR d'un shadow DOM ---------- */

  function deepAll(node, out = []) {
    if (node.shadowRoot) deepAll(node.shadowRoot, out);
    node.childNodes.forEach(c => {
      if (c.nodeType === 1) {
        out.push(c);
        deepAll(c, out);
      }
    });
    return out;
  }


  /* ---------- Lit le « TOTAL TTC » de la fiche produit ---------- */

  function readPageTotalCents() {

    const labels = [...document.querySelectorAll('body *')]
      .filter(n =>
        n.children.length === 0 &&
        TOTAL_RE.test(n.textContent || '') &&
        !n.closest('cart-drawer, dialog, [id*="cart-drawer" i]')
      );

    for (const label of labels) {

      let box = label.parentElement;

      for (let i = 0; i < 3 && box; i++, box = box.parentElement) {

        const m = (box.textContent || '')
          .replace(/\s+/g, ' ')
          .match(/(\d[\d .]*[.,]\d{2})\s*€/);

        if (m) {
          const value = parseFloat(m[1].replace(/[ .]/g, '').replace(',', '.'));
          if (!isNaN(value)) return Math.round(value * 100);
        }
      }
    }

    return null;
  }

  function formatEuros(cents) {
    return (cents / 100).toFixed(2).replace('.', ',');
  }


  /* ---------- Texte de la pastille : 4 échéances = total ÷ 4 ---------- */

  function readLabel() {

    const total = readPageTotalCents();

    if (total && total >= 5000) {
      const exact = total % 4 === 0;
      return (exact ? '' : T.approx + ' ') + '4 x ' + formatEuros(Math.round(total / 4)) + ' € ' + T.free + ({ fr: ' · ou 12x', en: ' · or 12x', de: ' · oder 12x' }[lang] || ' · ou 12x');
    }

    return T.fallback;
  }


  /* ---------- Clique sur le vrai lien du widget (ouvre la fenêtre Alma) ---------- */

  function almaModalVisible() {

    /* uniquement la fenêtre d'Alma, réellement visible à l'écran
       (les autres fenêtres du thème sont cachées mais ont une taille : elles faussaient le test) */
    return [...document.querySelectorAll('.md-modal__container, [class*="alma" i][class*="modal" i]')]
      .some(el => {
        if (el.closest('.mineral-alma-fallback, .mineral-alma-hidden')) return false;
        const st = getComputedStyle(el);
        if (st.display === 'none' || st.visibility === 'hidden' || parseFloat(st.opacity) === 0) return false;
        const r = el.getBoundingClientRect();
        return r.width > 100 && r.height > 100 &&
               r.right > 0 && r.bottom > 0 && r.left < window.innerWidth && r.top < window.innerHeight;
      });
  }

  function openAlmaModal(widget) {

    const all = deepAll(widget);

    const target =
      all.find(n => n.matches && n.matches('.alma-payment-plans-know-more-action, [class*="knowMore"]')) ||
      all.find(n => n.matches && n.matches('button.alma-payment-plans-active-option')) ||
      all.find(n => /^(a|button)$/i.test(n.tagName));

    if (target) {
      if (typeof target.focus === 'function') { try { target.focus({ preventScroll: true }); } catch (e) {} }
      if (typeof target.click === 'function') target.click();
    }

    /* Alma n'ouvre rien quand le prix à l'unité est sous son minimum (50 €) :
       on affiche alors notre propre fenêtre, calculée sur le total de la page */
    setTimeout(() => {
      const ok = almaModalVisible();
      console.log('[Pastille Alma] fenêtre Alma ouverte :', ok);
      if (!ok) openFallbackModal();
    }, 500);
  }


  /* ---------- Fenêtre de secours (échéancier 4x calculé sur le total) ---------- */

  const MODAL_T = {
    fr: {
      title: 'Payer en 4x ou 12x avec Alma',
      today: 'Aujourd’hui', month1: 'Dans 1 mois', month2: 'Dans 2 mois', month3: 'Dans 3 mois',
      intro4: 'Paiement en 4 fois sans frais',
      note12: 'Le paiement en 12x est aussi disponible (des frais s’appliquent). Le détail exact vous est présenté à l’étape de paiement.',
      none: 'Le paiement en 4x ou 12x est disponible à partir de 50 € d’achat. Le détail est présenté à l’étape de paiement.',
      total: 'Total', approx: 'Montants indicatifs', close: 'Fermer'
    },
    en: {
      title: 'Pay in 4x or 12x with Alma',
      today: 'Today', month1: 'In 1 month', month2: 'In 2 months', month3: 'In 3 months',
      intro4: 'Pay in 4 instalments, no fees',
      note12: '12x payment is also available (fees apply). The exact details are shown at checkout.',
      none: '4x or 12x payment is available for purchases from €50. Details are shown at checkout.',
      total: 'Total', approx: 'Indicative amounts', close: 'Close'
    },
    de: {
      title: 'In 4× oder 12× zahlen mit Alma',
      today: 'Heute', month1: 'In 1 Monat', month2: 'In 2 Monaten', month3: 'In 3 Monaten',
      intro4: 'Zahlung in 4 Raten ohne Gebühren',
      note12: 'Zahlung in 12 Raten ist ebenfalls möglich (es fallen Gebühren an). Die genauen Details sehen Sie beim Bezahlen.',
      none: 'Zahlung in 4× oder 12× ist ab einem Einkaufswert von 50 € möglich. Die Details sehen Sie beim Bezahlen.',
      total: 'Gesamt', approx: 'Unverbindliche Beträge', close: 'Schließen'
    }
  };

  let fallbackEl = null;

  function closeFallbackModal() {
    if (fallbackEl) { fallbackEl.remove(); fallbackEl = null; }
    document.removeEventListener('keydown', onFallbackKey, true);
  }

  function onFallbackKey(e) { if (e.key === 'Escape') closeFallbackModal(); }

  function openFallbackModal() {

    if (fallbackEl) return;

    const M = MODAL_T[lang] || MODAL_T.fr;
    const total = readPageTotalCents();
    const eur = c => formatEuros(c) + ' €';

    let body;

    if (total && total >= 5000) {

      const q = Math.floor(total / 4);
      const first = total - 3 * q;
      const rows = [[M.today, first], [M.month1, q], [M.month2, q], [M.month3, q]];

      body =
        '<p class="maf-intro">' + M.intro4 + '</p>' +
        '<ul class="maf-list">' +
        rows.map(r => '<li><span>' + r[0] + '</span><strong>' + eur(r[1]) + '</strong></li>').join('') +
        '</ul>' +
        '<p class="maf-total"><span>' + M.total + '</span><strong>' + eur(total) + '</strong></p>' +
        '<p class="maf-note">' + M.note12 + '</p>';

    } else {
      body = '<p class="maf-note">' + M.none + '</p>';
    }

    fallbackEl = document.createElement('div');
    fallbackEl.className = 'mineral-alma-fallback';
    fallbackEl.innerHTML =
      '<div class="maf-card" role="dialog" aria-modal="true">' +
      '<button type="button" class="maf-close" aria-label="' + M.close + '">×</button>' +
      '<h3>' + M.title + '</h3>' + body +
      '<button type="button" class="maf-btn">' + M.close + '</button>' +
      '</div>';

    fallbackEl.addEventListener('click', e => {
      if (e.target === fallbackEl || e.target.closest('.maf-close, .maf-btn')) closeFallbackModal();
    });

    document.body.appendChild(fallbackEl);
    document.addEventListener('keydown', onFallbackKey, true);
  }


  /* ---------- Supprime les marges / espaces vides laissés par le thème autour du widget ---------- */

  function onlyOurs(node, pill, widget) {

    return [...node.children].every(child => {

      if (child === pill || child === widget) return true;
      if (child.contains(pill) || child.contains(widget)) return true;

      /* un frère totalement vide (espaceur) ne compte pas */
      return (child.textContent || '').trim() === '' &&
             !child.querySelector('img, svg, button, input, iframe, video');
    });
  }

  function tidyWrappers(pill, widget) {

    let node = pill.parentElement;
    let depth = 0;

    while (node && node !== document.body && depth < 6) {

      if (!onlyOurs(node, pill, widget)) break;

      ['margin-top', 'margin-bottom', 'padding-top', 'padding-bottom', 'min-height']
        .forEach(prop => node.style.setProperty(prop, '0', 'important'));

      [...node.children].forEach(child => {
        if (child === pill || child === widget) return;
        if (child.contains(pill) || child.contains(widget)) return;
        child.style.setProperty('display', 'none', 'important');
      });

      node = node.parentElement;
      depth++;
    }
  }


  /* ---------- Trouve la ligne VISIBLE « En stock… / Sur commande… » juste avant la pastille ---------- */

  function findStockLine(pill) {

    /* le thème affiche le stock dans <span class="product__shipping-status"> */
    const known = [...document.querySelectorAll('.product__shipping-status')]
      .find(n => n.getClientRects().length > 0 && !n.closest('cart-drawer, dialog'));

    if (known) {

      let node = known;
      let guard = 0;

      /* un <span> est « en ligne » : on prend le bloc qui le contient */
      while (
        node.parentElement &&
        node.parentElement !== document.body &&
        window.getComputedStyle(node).display.indexOf('inline') === 0 &&
        guard++ < 3
      ) {
        node = node.parentElement;
      }

      /* si ce bloc est trop grand (il contient autre chose), le span devient lui-même un bloc */
      if (node !== known && node.getBoundingClientRect().height > 48) {
        known.style.display = 'block';
        node = known;
      }

      return { node, leaf: known };
    }

    const leaves = [...document.querySelectorAll('body *')].filter(n =>
      n.children.length === 0 &&
      !n.closest('.mineral-alma-pill') &&
      !n.closest('header, footer, nav, dialog, cart-drawer, [id*="cart-drawer" i]') &&
      (n.textContent || '').trim().length < 90 &&
      STOCK_RE.test(n.textContent || '') &&
      n.getClientRects().length > 0                         /* uniquement les éléments visibles */
    );

    const before = leaves.filter(n =>
      pill.compareDocumentPosition(n) & Node.DOCUMENT_POSITION_PRECEDING
    );

    const leaf = before[before.length - 1];
    if (!leaf) return null;

    /* on remonte jusqu'à l'élément qui contient toute la ligne (pastille verte + texte) */
    let node = leaf;
    const txt = leaf.textContent.trim();

    for (let i = 0; i < 3; i++) {
      const parent = node.parentElement;
      if (!parent || parent === document.body) break;
      if ((parent.textContent || '').replace(pill.textContent, '').trim() !== txt) break;
      node = parent;
    }

    return { node, leaf };
  }


  /* ---------- Remet la pastille à sa place d'origine (sous la ligne de stock) ---------- */

  function backHome(widget) {

    const pill = widget.mineralPill;
    if (!pill) return;

    pill.classList.remove('is-inline', 'is-overlap');
    ['margin-top', 'margin-bottom', 'margin-left']
      .forEach(prop => pill.style.removeProperty(prop));

    if (widget.parentNode && pill.parentNode !== widget.parentNode) {
      widget.parentNode.insertBefore(pill, widget);
    }
  }


  /* ---------- Ordinateur : pastille à droite, sur la ligne du stock, SI ASSEZ DE PLACE ---------- */

  function placeInline(widget) {

    const pill = widget.mineralPill;
    if (!pill) return;

    const stock = findStockLine(pill);

    if (!stock) {
      backHome(widget);
      return;
    }

    const { node, leaf } = stock;

    /* espace entre le bouton « Ajouter au panier » et la ligne de stock */
    node.style.setProperty('margin-top', SPACE_AFTER_CTA + 'px', 'important');

    if (!window.matchMedia(DESKTOP_QUERY).matches) {
      backHome(widget);
      return;
    }

    /* la pastille reste dans le DOM à sa place d'origine (le clic marche comme avant) :
       on la remonte visuellement sur la ligne du stock avec des marges négatives */
    if (pill.parentNode !== widget.parentNode) widget.parentNode.insertBefore(pill, widget);

    pill.classList.add('is-overlap');
    pill.style.setProperty('margin-top', '0px', 'important');
    pill.style.setProperty('margin-bottom', '0px', 'important');
    pill.style.setProperty('margin-left', 'auto', 'important');

    const box = pill.parentElement.getBoundingClientRect();
    const leafRect = leaf.getBoundingClientRect();
    const nodeRect = node.getBoundingClientRect();
    const pillRect = pill.getBoundingClientRect();

    /* assez de place sur la ligne ? sinon la pastille reste dessous */
    const fits = (leafRect.right - box.left) + 16 + pillRect.width <= box.width;

    /* la pastille doit être en dessous de la ligne de stock */
    if (!fits || pillRect.top < nodeRect.top) {
      backHome(widget);
      return;
    }

    const wanted = nodeRect.top + (nodeRect.height - pillRect.height) / 2;
    const delta = wanted - pillRect.top;               /* négatif : on remonte */

    pill.style.setProperty('margin-top', delta + 'px', 'important');
    pill.style.setProperty('margin-bottom', (-delta - pillRect.height) + 'px', 'important');
  }


  /* ---------- Mobile : force les écarts réduits (prioritaire sur les styles du thème) ---------- */

  function applyMobileSpacing(widget) {

    const mobile = !window.matchMedia(DESKTOP_QUERY).matches;
    const pill = widget.mineralPill;

    if (pill) {
      if (mobile) pill.style.setProperty('margin-top', MOBILE_PILL_TOP + 'px', 'important');
    }

    document.querySelectorAll('.mineral-delivery-wrap').forEach(block => {
      if (mobile) block.style.setProperty('margin-top', MOBILE_BLOCKS_TOP + 'px', 'important');
      else block.style.removeProperty('margin-top');
    });
  }


  /* ---------- Remplace l'encadré par la pastille ---------- */

  function compactAlma() {

    /* uniquement sur les fiches produit */
    if (!/\/products\//.test(location.pathname)) return;

    const found = [...document.querySelectorAll('[id*="alma" i], [class*="alma" i]')]
      .filter(el =>
        !el.closest('.mineral-alma-pill') &&
        !el.classList.contains('mineral-alma-pill') &&
        el.parentElement !== document.body &&
        !el.closest('footer, [id*="shopify-section"][id*="footer" i]') &&
        !/modal|overlay|backdrop/i.test(el.className + ' ' + el.id)
      );

    /* on garde seulement l'élément le plus haut */
    const top = found.filter(el => !found.some(o => o !== el && o.contains(el)));

    top.forEach(widget => {

      if (!widget.dataset.almaCompact) {

        widget.dataset.almaCompact = '1';

        const pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'mineral-alma-pill';
        pill.innerHTML =
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
          'stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>' +
          '<span class="mineral-alma-text"></span>' +
          '<span class="mineral-alma-info" aria-hidden="true">i</span>';

        pill.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          openAlmaModal(widget);
        });

        widget.parentNode.insertBefore(pill, widget);
        widget.classList.add('mineral-alma-hidden');
        widget.mineralPill = pill;

        tidyWrappers(pill, widget);
      }

      const pill = widget.mineralPill;
      if (!pill) return;

      /* si le thème a réécrit une zone et fait disparaître la pastille, on la remet */
      if (!pill.isConnected) backHome(widget);

      /* texte (prix / quantité qui changent) */
      const label = readLabel();
      const span = pill.querySelector('.mineral-alma-text');
      if (span && span.textContent !== label) span.textContent = label;

      /* même ligne que le stock, à droite */
      placeInline(widget);

      /* écarts réduits sur mobile */
      applyMobileSpacing(widget);

    });
  }

  /* Vitesse (oct. 2026) : la suite ne tourne que sur les fiches produit (ailleurs compactAlma ne faisait rien),
     et les appels declenches par les changements de la page sont regroupes : au plus une fois par image
     affichee (avant l'affichage, donc sans effet visible), au lieu d'une fois par modification. */
  if (!/\/products\//.test(location.pathname)) return;

  compactAlma();

  /* Le body ne voit pas les changements dans un shadow DOM :
     on rafraîchit donc aussi à intervalle régulier */
  setInterval(compactAlma, 800);

  let almaRaf = 0;
  function compactAlmaSoon() {
    if (almaRaf) return;
    almaRaf = requestAnimationFrame(() => { almaRaf = 0; compactAlma(); });
  }

  new MutationObserver(compactAlmaSoon).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

})();
